// src/pages/Pacientes.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Breadcrumb from '../components/Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/Pacientes.css';

// Axios con interceptor para el JWT
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: { 'Content-Type': 'application/json' }
});
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
);

export default function Pacientes() {
  const [filtro, setFiltro] = useState({
    n_expediente: '',
    nif: '',
    nombre: '',
    primer_apellido: '',
    segundo_apellido: '',
    telefono: '',
    movil: '',
    email: '',
    clinica: ''
  });
  const [pacientes, setPacientes] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();
  const [mostrarModalNuevo, setMostrarModalNuevo] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setFiltro(prev => ({ ...prev, [name]: value }));
  };

  const buscarPacientes = useCallback(async (filtrosPersonalizados = filtro) => {
    setLoading(true);
    setError(null);

    // Creamos un objeto sólo con los filtros no vacíos
    const params = Object.entries(filtro).reduce((acc, [k, v]) => {
      if (v !== ''){
        acc[k] = k === 'n_expediente' ? parseInt(v, 10) : v;
      }
      return acc;
    }, {});

    try {
      // Aquí pasamos `params`, no `filtro`
      const { data } = await api.get('/api/pacientes', { params });
      setPacientes(data);
      setSelectedId(null);
    } catch (err) {
      console.error(err.response?.data || err);
      toast.error("Dato erróneo, corrige la búsqueda");
    } finally {
      setLoading(false);
    }
  }, [filtro]);

 // useEffect(() => {
 //   buscarPacientes();
 // }, [buscarPacientes]);

  useEffect(() => {
    buscarPacientes();
  }, []);


  const handleRowClick = id => setSelectedId(id);
  const handleRowDoubleClick = id => history.push(`/pacientes/${id}`);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="pacientes-page">
        <Breadcrumb />
        <div className="page-header">
          <h2>Listado de Pacientes</h2>
          <button
            type="button"
            className="nuevo-btn"
            onClick={() => setMostrarModalNuevo(true)}
          >
            <span style={{ marginRight: '8px' }}>+</span> Nuevo Paciente
          </button>
        </div>
        <div className="filtro-form">
          {Object.keys(filtro).map((campo, idx) => {
            if (campo === "clinica") {
              return (
                <select
                  key="clinica"
                  name="clinica"
                  value={filtro.clinica}
                  onChange={handleChange}
                >
                  <option value="">-- Clínica --</option>
                  <option value="LA ELIPA">LA ELIPA</option>
                  <option value="VEN">VEN</option>
                </select>
              );
            }

            return (
              <input
                key={idx}
                type="text"
                name={campo}
                value={filtro[campo]}
                onChange={handleChange}
                placeholder={campo
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, l => l.toUpperCase())}
              />
            );
          })}
           {/* Botón Buscar */}
          <button 
            className="buscar-btn" 
            onClick={() => buscarPacientes()} 
            disabled={loading}
          >
            {loading ? 'Cargando...' : '🔍 Buscar'}
          </button>
        </div>

        {error && <div className="error-message">{error}</div>}
        {loading && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <div className="spinner"></div>
            <p>Cargando datos...</p>
          </div>
        )}
        {/* Tabla */}
        {!loading && (
          <table className="pacientes-table">
            <thead>
              {/* Eliminado el error del id y los eventos de click aquí */}
              <tr>
                <th>Expediente</th>
                <th>Nif</th>
                <th>Nombre</th>
                <th>Primer Apellido</th>
                <th>Segundo Apellido</th>
                <th>Teléfono</th>
                <th>Móvil</th>
                <th>Correo</th>
                <th>Clínica</th>
              </tr>
            </thead>
            <tbody>
              {pacientes.length > 0 ? (
                pacientes.map(p => {
                  const id = p.n_expediente;
                  const isSelected = selectedId === id;
                  return (
                    <tr
                      key={id}
                      onClick={() => handleRowClick(id)}
                      onDoubleClick={() => handleRowDoubleClick(id)}
                      // Usamos solo la clase, el CSS se encarga del color
                      className={isSelected ? 'selected' : ''}
                    >
                      <td>{p.n_expediente}</td>
                      <td>{p.nif}</td>
                      <td>{p.nombre}</td>
                      <td>{p.primer_apellido ?? p.primerApellido}</td>
                      <td>{p.segundo_apellido ?? p.segundoApellido}</td>
                      <td>{p.telefono}</td>
                      <td>{p.movil}</td>
                      <td>{p.email}</td>
                      <td>{p.clinica}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center', padding: '2rem' }}>
                    No hay pacientes que coincidan con el filtro.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
      {mostrarModalNuevo && (
        <div className="modal-overlay">
          <div className="modal-contenido">
            <h3>¿Cómo desea crear el paciente?</h3>

            <div className="modal-botones">
              <button
                className="accion-btn"
                onClick={() => {
                  setMostrarModalNuevo(false);
                  history.push('/pacientes/nuevo');
                }}
              >
                🖊 Manual
              </button>

              <button
                className="accion-btn accion-btn-tablet"
                onClick={() => {
                  setMostrarModalNuevo(false);
                  history.push('/formulario-publico');
                }}
              >
                📱 Tablet
              </button>
            </div>

            <button
              className="modal-cerrar"
              onClick={() => setMostrarModalNuevo(false)}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
